import type { ReactNode } from 'react';
import './FormField.css';

interface FormFieldProps {
  label: ReactNode;
  required?: boolean;
  error?: string;
  children: ReactNode;
  className?: string;
}

export function FormField({
  label,
  required = false,
  error,
  children,
  className = '',
}: FormFieldProps) {
  return (
    <div className={`form-field ${error ? 'form-field-error' : ''} ${className}`}>
      <label className="form-field-label">
        {label}
        {required && <span className="form-field-required">*</span>}
      </label>
      {children}
      {error && <p className="form-field-message">{error}</p>}
    </div>
  );
}
